<template>

  <div v-if="pageSensor != null && isLoginUserItemWritable(this.pageSensor)">

    <sensorTabs :current="'upload'" :pageSensor="pageSensor" :pageDevice="pageDevice" :pageUser="pageUser">

      <b-button type="button" variant="warning" class="float-right tabButton" size="sm" v-if="showUpdateButton">
        <b-spinner small type="grow" class="mr-0"></b-spinner>
        새 데이터 반영중
      </b-button>

    </sensorTabs>

    <div :class="(isLoginUserItemWritable(this.pageSensor))? 'writable pt-2':'notWritable pt-2'">

      <div v-if="isLoginUserItemWritable(this.pageSensor)">
        <b-alert class="m-0 mt-2 mb-2 p-1 pl-2 fontSizeDot9" show variant="danger" v-if="this.pageSensor.disabled == true || this.pageDevice.disabled == true">
          정지 중이므로 기기의 정보를 변경할 수 없습니다.
        </b-alert>
      </div>

      <b-form @submit.stop.prevent class="was-validated">

        <b-input-group size="sm" class="mt-2">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label class="mb-0" for="csvTimeFormat">CSV 날짜 형식</label>
          </b-input-group-text>
          <b-form-select size="sm" id="csvTimeFormat" required v-model="csvTimeFormat" :options="[
          {value: 'excel', text: '엑셀 맞춤형: 1999-12-31 23:59:59'},
            {value: 'epoch', text: '숫자(유닉스 시간): 1970년 1월 1일 경과 시간(초)'},
            {value: 'dtstr', text: '문자열(ISO8601): 1999-12-31T23:59:59+09:00'},
          ]">
          </b-form-select>
        </b-input-group>

        <b-input-group size="sm" class="mt-1">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label class="mb-0" for="csvValueSeperator">CSV 값 구분자</label>
          </b-input-group-text>
          <b-form-input size="sm" v-touch:swipe.stop v-model="csvValueSeperator"   id="csvValueSeperator" v-b-tooltip.hover title="CSV 데이터의 열 구분자로 사용합니다." minlength="1" trim/>
        </b-input-group>

        <b-input-group size="sm" class="mt-1">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label class="mb-0" for="csvRowSeperator">CSV 줄 구분자</label>
          </b-input-group-text>
          <b-form-input size="sm" minlength="1" v-touch:swipe.stop v-model="csvRowSeperator" id="csvRowSeperator" v-b-tooltip.hover title="CSV 데이터의 행 구분자로 사용합니다." trim/>
        </b-input-group>

        <b-input-group size="sm" class="mt-1">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label class="mb-0" for="sampleValueDifferentSelected">샘플 데이터</label>
          </b-input-group-text>
          <b-form-select size="sm" v-model="sampleValueDifferentSelected" id="sampleValueDifferentSelected" :options="[
            { value: true, text: '줄 마다 다른 값' },
            { value: false, text: '줄 마다 같은 값' }
          ]">
          </b-form-select>
          <b-form-select size="sm" v-model="sampleRowCountSelected" :options="[
            { value: 1, text: '1 줄' },
            { value: 10, text: '10 줄' },
            { value: 50, text: '50 줄' },
            { value: 100, text: '100 줄' }
          ]">
          </b-form-select>
          <b-button variant="primary" class="pl-3 pr-3" style="min-width: 7rem;" slot="append" @click="createSampleData">
            만들기
          </b-button>
        </b-input-group>

        <b-input-group size="sm" class="mt-3">
          <b-input-group-text slot="prepend" class="leftCellTitle bg-primary text-light">
            <label class="mb-0 font-weight-bold " for="dataFiles">파일 업로드</label>
          </b-input-group-text>

          <b-form-file size="sm" no-traverse multiple v-model="dataFiles" id="dataFiles" placeholder="업로드할 CSV나 바이너리 파일들을 선택하세요." drop-placeholder="여기에 파일들을 떨어뜨리세요." @input="convertFilesToData()" accept=".txt, .TXT, .csv, .CSV, .bin, .BIN"></b-form-file>
        </b-input-group>

        <b-input-group size="sm" class="mt-3">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label class="mb-0" for="gridDataLength">업로드 데이터 개수</label>
          </b-input-group-text>
          <b-form-input size="sm" readonly v-touch:swipe.stop v-model="gridData.length" id="gridDataLength" trim/>
          <b-button variant="danger" class="pl-1 pr-1 text-center" slot="append"  @click="uploadGridData" :disabled="gridData.length == 0 || (csvData != '' && csvDataDirty && !isGridDataMerged && dataTabIndex != 2) || (jsonData != '' && jsonDataDirty && !isGridDataMerged && dataTabIndex != 2) || gridDataRowCountDuplicated != 0 || pageSensor.disabled == true || pageDevice.disabled == true" style="min-width: 7rem;">
            업로드 하기
          </b-button>
        </b-input-group>

        <div class="mt-1 gothic gridColumn">
          <div class="gridColumnTitle">
            데이터 최종 시간
          </div>
          <div class="gridColumnBody">
            {{
              (this.pageSensor.lastValues == null) ? "": this.dateToString(new Date(this.pageSensor.lastValues.t.seconds*1000))
            }}
          </div>
        </div>

        <div class="mt-1 gothic gridColumn" v-if="this.gridData.length!=0">
          <div class="gridColumnTitle">업로드 데이터 시간</div>
          <div class="gridColumnBody">
            {{ this.dateToString(this.gridData[0].d.t.toDate()) }}
              ~
            {{ this.dateToString(this.gridData[this.gridData.length-1].d.t.toDate()) }}
          </div>
        </div>

        <div class="mt-3 gothic gridColumn" v-if="isGridDataMerged">
          <div class="gridColumnTitle">업로드 합치기 개수</div>
          <div class="gridColumnBody">
            신규 {{this.gridDataRowCountNew}} 줄 + 저장된 {{this.gridDataRowCountMerged}} 줄
          </div>
        </div>

      </b-form>

      <b-tabs pills card align="center" v-model="dataTabIndex" class="mt-1 border bg-secondary-lighter uploadTabs">

        <b-tab title="JSON" @click="clickTab(0)" :disabled="this.isGridDataMerged">
          <b-form-textarea v-touch:swipe.stop rows="6" v-model="jsonData" @keyup="setJsonDataDirty()" class="mt-2 fontSizeDot9"></b-form-textarea>
        </b-tab>

        <b-tab title="CSV" @click="clickTab(1)" :disabled="this.isGridDataMerged" active>
          <b-form-textarea v-touch:swipe.stop rows="6" v-model="csvData" @keyup="setCsvDataDirty()" class="mt-2 fontSizeDot9"></b-form-textarea>
        </b-tab>

        <b-tab title="List" @click="clickTab(2)">

          <div class="menuRow fontSizeDot8 gothic p-0 border border-secondary-light" style="align-items: center;">
            <div style="grid-area: left;">
              <div v-if="gridDataRowCountSelected > 0" class="gridAreaBorderRight d-inline-block p-1 fontSizeDot8">
                <span class="ml-2 mr-2 align-middle">선택: {{this.gridDataRowCountSelected}} 개</span>
                <b-button variant="secondary" size="sm" class="m-0 mr-1 pl-1 pr-1 pt-dot1 pb-dot1 fontSizeDot8" @click="clearSelection" v-b-tooltip.hover title="선택을 취소합니다.">
                  취소
                </b-button>
                <b-button variant="primary" size="sm" class="m-0 mr-1 pl-1 pr-1 pt-dot1 pb-dot1 fontSizeDot8" @click="deleteSelection" v-b-tooltip.hover title="선택된 줄을 업로드 목록에서 삭제합니다.">
                  삭제
                </b-button>
              </div>

              <div class="gridAreaBorderRight d-inline-block p-1 fontSizeDot9" v-if="gridDataRowCountDuplicated > 0">
                <b-form-select size="sm" v-model="selectExceptPriority" class="ml-1 fontSizeDot8 pl-1 pr-1" v-b-tooltip.hover title="'저장된'을 선택하면 저장된 줄을 우선으로 남기고, '새로운'을 선택하면 새로운 줄을 우선으로 남기고 나머지를 선택합니다." style="width: 4rem;">
                  <option value="saved">저장된</option>
                  <option value="new">새로운</option>
                </b-form-select>
                <span> 1 줄 남기고</span>
                <b-button variant="secondary" size="sm" class="ml-2 pt-dot1 pb-dot1 pl-1 pr-1 fontSizeDot8" @click="selectDuplicatedRow" v-b-tooltip.hover title="시간이 같은 줄들은 한줄만 남기고 모두 선택합니다. 저장된 줄을 남길 지, 새로운 줄을 남길 지 선택할 수 있습니다.">
                  나머지 선택하기
                </b-button>
              </div>

            </div>
            <div style="grid-area: right;" class="text-right fontSizeDot8">
              <div class="gridAreaBorderLeft d-inline-block p-1 fontSizeDot8">
                <b-form-select v-model="gridPerPage" class="m-0 mr-1 fontSizeDot8" :options="gridPerPageList" size="sm"></b-form-select>
              </div>
            </div>
          </div>

          <div class="gothic mt-1 overflowScrolllMax589">
            <b-table v-touch:swipe.stop striped bordered head-variant="dark" hover :fields="gridFields" :items="gridData" class="dataGrid" :no-sort-reset="true" :no-provider-paging="true" selectable select-mode="range" selectedVariant="primary" @row-selected="gridRowSelected" :no-provider-sorting="true" :no-provider-filtering="true" :show-empty="true" empty-text="" primary-key="id" :per-page="gridPerPage" :current-page="gridCurrentPage" id="sensorUpload" :sort-by.sync="gridSortBy" :sort-desc.sync="gridSortDesc">
              <template v-slot:cell(s)="data">
                <input type="checkbox" v-model="data.item.s"/>
              </template>
            </b-table>
          </div>

          <div style="position:relative;">

            <div style="position: absolute; left: 10px; padding: 0ex 2ex 2ex 0ex; " class="gothic">
              <span style="vertical-align:-1px;font-size: 0.9rem;">{{this.gridData.length}}줄</span>
            </div>

            <div style="position:absolute; right: 10px; vertical-align:-1px;font-size: 0.9rem;">
              <div style="padding: 0ex 0ex 2ex 2ex; " class="gothic" v-if="this.gridData.length != 0">
                <b-input size="sm" v-model="gridCurrentPage" style="width: 50px; text-align: right; display:inline" class="ml-1"></b-input>/
                <span>{{ Math.ceil(this.gridData.length/this.gridPerPage) }}페이지</span>
              </div>
            </div>

            <b-pagination v-model="gridCurrentPage" :total-rows="this.gridData.length" :per-page="gridPerPage" first-text="|‹" last-text="›|" aria-controls="grid" size="sm" align="center">
            </b-pagination>
          </div>
        </b-tab>
      </b-tabs>

      <ul class="gothic fontSizeDot9 mt-3 ml-0 pl-3">

        <li style="font-size: 0.9rem">데이터 업로드 결과 메시지 상자는 1분 뒤에 사라집니다.</li>

        <li v-if="this.csvData != '' && this.csvDataDirty && !this.isGridDataMerged && this.dataTabIndex != 2" style="color:red; font-weight: bold;">반영되지 않은 CSV 데이터가 있습니다. List 탭을 눌러주세요.</li>

        <li v-else-if="this.jsonData != '' && this.jsonDataDirty && !this.isGridDataMerged && this.dataTabIndex != 2" style="color:red; font-weight: bold;">반영되지 않은 JSON 데이터가 있습니다. </li>

        <li v-else-if="this.gridDataRowCountDuplicated != 0" style="color:red; font-weight: bold;">시간이 동일한 데이터가 있습니다. 1개만 남기고 나머지는 삭제해주세요.</li>

        <li v-if="this.isGridDataMerged" style="font-size: 0.9rem; color:red;font-weight: bold;">서버의 데이터와 합친 경우에는 JSON, CSV 탭을 사용할 수 없습니다.</li>

      </ul>
    </div>

    <!--b-modal v-touch:swipe.stop size="lg" id="uploadFunctionServerFloat" tabindex="-1" title="데이터 업로드하기" static @show="modalShowFocus" header-bg-variant="primary" header-text-variant="light" footer-bg-variant="light" footer-text-variant="primary" header-class="pt-2 pb-2 pr-3 pl-3" footer-class="pt-1 pb-1 pr-3 pl-3" content-class="border-0" button-size="sm" data-nextfocus="closeUploadFunctionServer">
      <p class="gothic">
        현재 서버에 저장된 데이터가 전혀 없습니다. 이런 경우에 실제 IoT 보드에서 데이터를 업로드하는
        방식과 동일하게 별도의 업로드 서버를 거쳐서 데이터를 업로드합니다.
      </p>
      <template slot="modal-footer">
        <b-button variant="outline-secondary" size="sm" @click="uploadFunctionServer" :disabled="!this.pageBinded" v-b-tooltip.hover title="업로드 서버를 거쳐서 업로드 하기">
          <b-spinner small type="grow" class="mr-1" v-if="uploadFunctionServerSpinner"></b-spinner>
          업로드 하기
        </b-button>
        <b-button variant="primary" id="closeUploadFunctionServer" @click="uploadFunctionServer"  v-b-tooltip.hover title="현재 창을 닫습니다.">
          취소하기
        </b-button>
      </template>
    </b-modal-->
    <b-modal v-touch:swipe.stop size="lg" id="confirmDataMixFloat" tabindex="-1" title="저장된 데이터 가져와서 합친 후에 업로드하기" static @show="modalShowFocus" data-nextfocus="closeConfirmDataMixButton" header-bg-variant="primary" header-text-variant="light" footer-bg-variant="light" footer-text-variant="primary" header-class="pt-2 pb-2 pr-3 pl-3" footer-class="pt-1 pb-1 pr-3 pl-3" content-class="border-0" button-size="sm">
      <p>
        서버에 저장된 데이터의 최종 시간(<b>{{(this.pageSensor.lastValues == null) ? "": this.dateToString(this.pageSensor.lastValues.t.toDate())}}</b>)이
        업로드하려는 데이터의 시작 시간(<b>{{(this.gridData.length == 0)? "":this.dateToString(this.gridData[0].d.t.toDate())}}</b>)보다 늦습니다.
        서버에서 업로드하려는 데이터의 시작 시간 이후 데이터가 포함된 묶음(총 {{this.mergeRowCount}}줄)을
        가져와서 합친 다음에 업로드해야 합니다.
      </p>
      <template slot="modal-footer">
        <b-button variant="outline-secondary" size="sm" @click="preloadHistoryData" :disabled="!this.pageBinded" v-b-tooltip.hover title="서버에서 데이터를 가져와서 합칩니다. 데이터를 검토 후에 업로드할 수 있습니다.">
          저장된 데이터 {{this.mergeRowCount}}줄 가져와서 합치기
        </b-button>
        <b-button variant="primary" id="closeConfirmDataMixButton" @click="closeConfirmDataMix"  v-b-tooltip.hover title="현재 창을 닫습니다.">
          취소하기
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>

import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import { db } from "@/plugins/firebase.js"

import uiUtil from "@/mixins/util.js"
import user from "@/mixins/user.js"
import functions from "@/mixins/functions.js"

import sensorTabs from "@/components/sensor/sensorTabs.vue"

export default {
  name: "sensorUpload",
  mixins: [uiUtil, user, functions],
  props: {
    pageUser: {
      type: Object,
      default: null
    },
    pageDevice: {
      type: Object,
      default: null
    },
    pageSensor: {
      type: Object,
      default: null
    },
    pageSensorHistory: {
      type: Object,
      default: null
    },
    pageBinded: {
      type: Boolean,
      default: false
    },
  },
  components: {
    sensorTabs,
  },
  mounted: function() {
    this.init();
  },

  updated: function() {
    if(this.pageDevice.active) {



      // 데이터수는 같은 데 데이터가 달라졌다.
      if(this.rowCount == this.sensorRowCount) {
        if(this.pageSensor != null && this.pageSensor.lastValuesModified != null && this.lastValuesModified != null && this.lastValuesModified.getTime() != this.pageSensor.lastValuesModified.toDate().getTime()) {
          if(!this.gridUpdating) {
            this.$parent.$parent.makeToast("danger", "데이터 동기화", "데이터 수는 같은 데 최종 수정일이 달라졌습니다. 화면을 초기화했습니다.", {
              "autoHideDelay": 5000
            })
            this.$set(this.$parent.$parent, "pageSensorHistory", {});

            this.lastBook = this.pageSensor.lastBook
            this.lastIndex = this.pageSensor.lastIndex
            this.lastValuesModified = (this.pageSensor.lastValuesModified == null)? null : this.pageSensor.lastValuesModified.toDate()

          }
        }
      }

      // 데이터가 줄어들었다.
      else if((this.sensorRowCount - this.rowCount) < 0) {
        if(!this.gridUpdating) {

          this.$parent.$parent.makeToast("danger", "데이터 동기화", "서버에 저장된 데이터 수가 현재 데이터 수보다 적습니다. 화면을 초기화했습니다.",{
            "autoHideDelay": 5000
          })

          this.$set(this.$parent.$parent, "pageSensorHistory", {});

          this.lastBook = this.pageSensor.lastBook
          this.lastIndex = this.pageSensor.lastIndex
          this.lastValuesModified = (this.pageSensor.lastValuesModified == null)? null : this.pageSensor.lastValuesModified.toDate()

        }
      }


      // 1줄 늘어났다.
      else if((this.sensorRowCount - this.rowCount) == 1) {
        this.showUpdateButton = true
        window.setTimeout(()=>{
          this.showUpdateButton = false
        },1500);


        if(this.pageSensor.lastIndex == 0) {
          this.$set(this.$parent.$parent.pageSensorHistory, this.pageSensor.lastBook+ "", {
            dirty: false,
            data: {}
          });
        }


        if(typeof(this.$parent.$parent.pageSensorHistory[this.pageSensor.lastBook + ""]) != "undefined") {
          this.$set(this.$parent.$parent.pageSensorHistory[this.pageSensor.lastBook + ""].data, this.pageSensor.lastIndex+ "", this.pageSensor.lastValues);
        }

        this.lastBook = this.pageSensor.lastBook
        this.lastIndex = this.pageSensor.lastIndex
        this.lastValuesModified = (this.pageSensor.lastValuesModified == null)? null : this.pageSensor.lastValuesModified.toDate()
      }

      // 1줄 이상 늘어났다.
      else if((this.sensorRowCount - this.rowCount) > 1) {
        if(!this.gridUpdating) {
          this.$parent.$parent.makeToast("info", "데이터 동기화", "한꺼번에 여러 줄의 데이터가 늘어나서 화면을 초기화했습니다.",{
            "autoHideDelay": 5000
          })
          this.$set(this.$parent.$parent, "pageSensorHistory", {});
          this.lastBook = this.pageSensor.lastBook
          this.lastIndex = this.pageSensor.lastIndex
          this.lastValuesModified = (this.pageSensor.lastValuesModified == null)? null : this.pageSensor.lastValuesModified.toDate()
        }
      }
    }
    else {
      if(!this.gridUpdating) {
        if(
            (this.lastValuesModified == null && this.pageSensor.lastValuesModified != null)||
            (this.lastValuesModified != null && this.pageSensor.lastValuesModified == null)||
            (this.pageSensor != null && this.pageSensor.lastValuesModified != null && this.lastValuesModified != null && this.lastValuesModified.getTime() != this.pageSensor.lastValuesModified.toDate().getTime())
        ) {

          this.$parent.$parent.makeToast("danger", "데이터 동기화", "데이터가 수정되어 캐시된 데이터를 초기화합니다.", {
            "autoHideDelay": 5000
          })
          this.$set(this.$parent.$parent, "pageSensorHistory", {});

          this.lastBook = this.pageSensor.lastBook
          this.lastIndex = this.pageSensor.lastIndex
          this.lastValuesModified = (this.pageSensor.lastValuesModified == null)? null : this.pageSensor.lastValuesModified.toDate()
        }
      }
    }
  },
  data: function() {
    return {

      serial: null,
      acode: null,
      // uploadFunctionServerSpinner:false,

      gridUpdating: false,
      showUpdateButton: false,

      lastBook: null,
      lastIndex: null,
      lastValuesModified: null,
      pageSensorValuesFiltered: null,

      sampleRowCountSelected: 1,
      dataTabIndex: 0,
      jsonDataDirty: false,
      jsonData: "",
      csvDataDirty: false,
      csvData: "",
      gridFields: [],
      gridCurrentPage: 1,
      gridData: [],
      isGridDataMerged: false,
      maxGridDataMergeLength: 5,
      sameSecondRowCount: 0,

      gridPerPage: 10,
      gridPerPageList: [10, 25, 50, 100, 250, 1000],
      gridSortBy: "id",
      gridSortDesc: true,

      dataFiles: [],

      sampleValueDifferentSelected: true,

      selectExceptPriority: "new",
      csvTimeFormat: "epoch",
      csvValueSeperator: ",",
      csvRowSeperator: "\\n",
      resultHTML: "",
    }
  },
  created: function() {
    firebase.auth().onAuthStateChanged(() => {
      if(firebase.auth().currentUser != null) {
        this.getAcode();
      }
    });
  },
  computed: {
    onlyCotainsLateValues: function() {
      if(this.pageSensor.lastValues == null) return true;
      if(this.gridData.length == 0) return true;
      if(this.pageSensor.lastValues.t.seconds < this.gridData[0].d.t.seconds) return true;
      return false;
    },
    gridDataRowCountSelected: function() {
      if(this.gridData == null) return 0;
      return this.gridData.filter(item=>{ if(item.s) return true; else return false}).length;
    },
    mergeRowCount: function() {
      if(this.gridData.length == 0) return 0;
      if(this.onlyCotainsLateValues) return 0;
      let bookIndex = this.getBookIndexFrom(this.gridData[0].d.t.seconds);
      return (this.pageSensor.lastBook-bookIndex)*1000 + this.pageSensor.lastIndex + 1;
    },
    rowCount: function() {
      return parseInt(this.lastBook)*1000 + parseInt(this.lastIndex) + 1;
    },
    gridDataRowCountNew: function() {
      return this.gridData.filter(item=>{if(item.n) return true; else return false; }).length;
    },
    gridDataRowCountMerged: function() {
      return this.gridData.filter(item=>{if(item.n) return false; else return true; }).length;
    },
    gridDataRowCountDuplicated: function() {
      return this.gridData.filter(item=>{if(item._rowVariant == "danger") return true; else return false; }).length;
    },

    sensorRowCount: function() {
      return this.pageSensor.lastBook*1000 + this.pageSensor.lastIndex + 1;
    },

  },
  methods: {
    selectDuplicatedRow: function() {

      for(let i=0;i<(this.gridData.length-1);i++) {

        if(typeof(this.gridData[i]._rowVariant) != "undefined" && this.gridData[i]._rowVariant == "danger") {

          let newDuplicatedList = [];
          let savedDuplicatedList = [];

          if(this.gridData[i].n) newDuplicatedList.push(i);
          else savedDuplicatedList.push(i);

          let j;



          for(j=(i+1);j<this.gridData.length;j++) {
            if(this.gridData[j].d.t.seconds == this.gridData[i].d.t.seconds) {
              if(this.gridData[j].n) newDuplicatedList.push(j);
              else savedDuplicatedList.push(j);
            }
            else {
              break;
            }
          }


          if(this.selectExceptPriority == "new") {
            if(newDuplicatedList.length != 0) {

              newDuplicatedList.forEach((item, index) => {
                if(index == 0) this.gridData[item].s = false;
                else this.gridData[item].s = true;
              });

              savedDuplicatedList.forEach((item, index) => {
                this.gridData[item].s = true;
              });

            }
            else {

              savedDuplicatedList.forEach((item, index) => {
                if(index == 0) this.gridData[item].s = false;
                else this.gridData[item].s = true;
              });

            }
          }

          else {
            if(savedDuplicatedList.length != 0) {

              savedDuplicatedList.forEach((item, index) => {
                if(index == 0) this.gridData[item].s = false;
                else this.gridData[item].s = true;
              });

              newDuplicatedList.forEach((item, index) => {
                this.gridData[item].s = true;
              });
            }
            else {
              newDuplicatedList.forEach((item, index) => {
                if(index == 0) this.gridData[item].s = false;
                else this.gridData[item].s = true;
              });
            }
          }
          i = j-1;
        }
        else {
          this.gridData[i].s = false;
        }
      }
      this.$root.$emit('bv::refresh::table', 'sensorUpload');
    },

    getAcode: function() {
      db.collection("acodes").where("device", "==", this.pageDevice.id).where("owner", "==", this.pageUser.id)
      .get()
      .then(acodeList => {
        acodeList.forEach(acode => {
          if(acode.exists) {
            this.serial = acode.data().serial
            this.acode = acode.id
          }
        })
      })
      .catch(error => {
        this.makeToast("danger", "접속 코드 조회 실패", "접속 코드 조회 중에 에러가 발생했습니다. 에러 내용:" + error)
      })
    },


    // closeUploadFunctionServer: function() {
    //   this.hideModal('uploadFunctionServerFloat');
    // },

    uploadFunctionServer: function() {

      // this.uploadFunctionServerSpinner = true;


      let oldActive = this.pageDevice.active;
      if(!oldActive) {
        db.collection("devices").doc(this.pageDevice.id).update({
          active: true
        })
      }

      let sendURI = this.functionsServer;
      sendURI += "/app/adc?acode=";
      sendURI += this.acode;
      sendURI += "&sensor=";
      sendURI += this.pageSensor.name;
      sendURI += "&response=json&rowDelimiter=";
      sendURI += encodeURIComponent("\n");
      sendURI += "&cellDelimiter=";
      sendURI += encodeURIComponent(",");
      sendURI += "&rkey=0616";
      sendURI += "&afd=1";

      if(this.csvDataDirty) {
        this.applyGridToCsv();
        this.csvDataDirty = false;
      }

      this.postText(sendURI, this.csvData)
      .then(result=> {
        if(result.status != 200) {
          this.makeToast("danger", "서버 업로딩 실패", "서버로 데이터 업로딩 중에 에러가 발생했습니다. 상태 코드: " + result.status + ", 상태 메시지: " + result.statusText);
          // this.uploadFunctionServerSpinner = false;
          // this.closeUploadFunctionServer();

          if(!oldActive) {
            db.collection("devices").doc(this.pageDevice.id).update({
              active: false
            })
          }
        }
        else {
          if(result.data.success) {
            this.makeToast("success", "서버 업로딩 성공", "서버로 데이터를 업로딩 했습니다.");
            this.resetGrid();
            // this.uploadFunctionServerSpinner = false;
            // this.closeUploadFunctionServer();
          }
          else {
            this.makeToast("success", "서버 업로딩 실패", "서버로 데이터를 업로드했으나 에러가 났습니다. 응답값:" + JSON.stringify(result.data));
            // this.uploadFunctionServerSpinner = false;
            // this.closeUploadFunctionServer();
          }
          if(!oldActive) {
            db.collection("devices").doc(this.pageDevice.id).update({
              active: false
            })
          }
        }
      })
      .catch(error => {
        this.makeToast("danger", "서버 업로딩 실패", "서버로 요청을 보내지 못했습니다. error: " + error);
        if(!oldActive) {
          db.collection("devices").doc(this.pageDevice.id).update({
            active: false
          })
        }
        // this.uploadFunctionServerSpinner = false;
        // this.closeUploadFunctionServer();
      });
    },
    closeConfirmDataMix: function() {
      this.hideModal('confirmDataMixFloat');
    },
    clearSelection: function() {
      this.gridData.forEach(item => {
        item.s = false;
      })
    },
    deleteSelection: function() {
      this.gridData = this.gridData.filter(item=>{if(item.s) return false; else return true;});
      this.csvDataDirty = true;
      this.jsonDataDirty = true;
      this.markSameSecondAndSetIDAndSortByDuplicated();
    },
    gridRowSelected: function(items) {
      items.forEach(item => { item.s = true; });
    },
    init: function() {

      this.pageSensorValuesFiltered = this.pageSensor.values.filter(element => {
        return !element.hold
      });

      this.gridFields.push({
        "key": "s",
        "label": "✓",
        "tdClass": "centerTd"
      });

      this.gridFields.push({
        "key": "id",
        "label": "ID",
        "sortable": true,
        "tdClass": "dataTd"
      });

      this.gridFields.push({
        "key": "d.t",
        "label": "시간",
        "sortable": true,
        "sortDirection": "enc",
        "tdClass": "timeTd",
        "formatter": value => {
          if(value == null) {
            return "null";
          }
          else {
            return this.dateToString(value.toDate());
          }
        }
      });

      this.pageSensorValuesFiltered.forEach((item, index) => {
        this.gridFields.push( {
          "key": "d.v[" + index + "]",
          "label": item.name,
          "sortable": true,
          "sortDirection": "desc",
          "tdClass": "dataTd"
        });
      });

      this.gridFields.push({
        "key": "n",
        "label": "신규",
        "sortable": true,
        "sortDirection": "enc",
        "tdClass": "centerTd",
        "formatter": value => {
          if(value === true) {
            return "O";
          }
          else {
            return "X";
          }
        }
      });

      this.gridFields.push({
        "key": "_rowVariant",
        "label": "중복",
        "sortable": true,
        "sortDirection": "desc",
        "tdClass": "centerTd",
        "formatter": value => {
          if(value === "danger") {
            return "O";
          }
          else {
            return "X";
          }
        }
      });

      this.lastBook = this.pageSensor.lastBook;
      this.lastIndex = this.pageSensor.lastIndex;
      this.lastValuesModified = (this.pageSensor.lastValuesModified == null)? null: this.pageSensor.lastValuesModified.toDate();

    },
    getTitle: function(item) {
      if(typeof(item.unit) == "undefined" || item.unit == "") {
        if(item.title.length > 6) return item.title.substring(0,7);
        else return item.title;
      }
      else {
        if(item.title.length > 6) return item.title.substring(0,5) + "(" + item.unit + ")";
        else return item.title + "(" + item.unit + ")";
      }
    },
    getBookIndexFrom: function(dt) {
      let bookIndex=this.pageSensor.lastBook;
      if(this.pageSensor.lastValues == null) return 0;
      // if(this.pageSensor.lastValues.t.seconds<dt) return bookIndex + 1;
      for(;bookIndex>=0;bookIndex--) {
        if(this.pageSensor.bookInfo[bookIndex].from.seconds <= dt) break;
      }
      if(bookIndex== -1) bookIndex = 0;
      return bookIndex;
    },

    applyGridToCsv: function() {
      let result = "";
      let rowSeperator = this.csvRowSeperator.replace("\\n", "\n").replace("\\t", "\t")
      let valueSeperator = this.csvValueSeperator.replace("\\n", "\n").replace("\\t", "\t")
      if(this.csvTimeFormat == "epoch") {
        this.gridData.forEach((row, rowIndex) => {
          result += [row.d.t.seconds,...row.d.v].join(valueSeperator) + ((rowIndex != (this.gridData.length-1))? rowSeperator : "");
        });
      }
      else if(this.csvTimeFormat == "dtstr") {
        this.gridData.forEach((row, rowIndex) => {
          result += [this.toISOString(row.d.t.toDate()),...row.d.v].join(valueSeperator) + ((rowIndex != (this.gridData.length-1))? rowSeperator : "");
        });
      }
      else if(this.csvTimeFormat == "excel") {
        this.gridData.forEach((row, rowIndex) => {
          result += [this.dateToString(row.d.t.toDate()),...row.d.v].join(valueSeperator) + ((rowIndex != (this.gridData.length-1))? rowSeperator : "");
        });
      }
      this.csvData = result;
    },

    applyGridToJson: function() {
      let result = [];

      if(this.csvTimeFormat == "dtstr") {
        this.gridData.forEach(row => {
          let item = {};
          item.dtstr = this.toISOString(row.d.t.toDate());
          this.pageSensorValuesFiltered.forEach((value,index)=>{
            item[value.name] = row.d.v[index]*1;
          });
          result.push(item);
        });
      }
      else {
        this.gridData.forEach(row => {
          let item = {};
          item.dt = row.d.t.seconds;
          this.pageSensorValuesFiltered.forEach((value,index)=>{
            item[value.name] = row.d.v[index]*1;
          });
          result.push(item);
        });
      }

      this.jsonData = JSON.stringify(result, null);

    },

    applyJsonToGrid: function() {
      try {
        if(this.jsonData == "") return;
        let jsonObject = JSON.parse(this.jsonData);
        let result = [];
        let errorMessage = "";

        jsonObject.forEach(row => {
          let success = true;
          let item = {};
          item.d = {};

          if(typeof(row.dt) != "undefined") {
            item.d.t = firebase.firestore.Timestamp.fromMillis(row.dt*1000);
            item.d.v = [];
            item.n = true;
            item.s = false;
            this.pageSensorValuesFiltered.forEach((value)=>{
              if(typeof(row[value.name]) != "undefined") {
                if(value.type == "BOOL_VAL") {
                  if(typeof(row[value.name]) == "boolean") {
                    item.d.v.push((row[value.name] === true)? true: false);
                  }
                  else if(typeof(row[value.name]) == "number") {
                    item.d.v.push((row[value.name] > 0)? true: false);
                  }
                  else if(typeof(row[value.name]) == "string") {
                    item.d.v.push((row[value.name].toLowerCase() == "true" || row[value.name] == "1" )? true: false);
                  }
                  else {
                    item.d.v.push(((new Boolean(row[value.name])) == true)? true: false);
                  }
                }
                else {
                  item.d.v.push(row[value.name]);
                }
              }
              else {
                success = false;
              }
            });
            if(success) {
              result.push(item);
            }
            else {
              errorMessage += "값이 없는 항목이 있습니다. " + JSON.stringify(row, null," ") + " ";
            }
          }
          else if(typeof(row.dtstr) != "undefined") {
            item.d.t = firebase.firestore.Timestamp.fromDate(new Date(row.dtstr));
            item.d.v = [];
            item.n = true;
            item.s = false;
            this.pageSensorValuesFiltered.forEach((value)=>{
              if(typeof(row[value.name]) != "undefined") {
                if(value.type == "BOOL_VAL") {
                  if(typeof(row[value.name]) == "boolean") {
                    item.d.v.push((row[value.name] === true)? true: false);
                  }
                  else if(typeof(row[value.name]) == "number") {
                    item.d.v.push((row[value.name] > 0)? true: false);
                  }
                  else if(typeof(row[value.name]) == "string") {
                    item.d.v.push((row[value.name].toLowerCase() == "true" || row[value.name] == "1" )? true: false);
                  }
                  else {
                    item.d.v.push(((new Boolean(row[value.name])) == true)? true: false);
                  }
                }
                else {
                  item.d.v.push(row[value.name]);
                }
              }
              else {
                success = false;
              }
            });
            if(success) {
              result.push(item);
            }
            else {
              errorMessage += "값이 없는 항목이 있습니다. " + JSON.stringify(row,null," ") + " ";
            }
          }
          else {
            errorMessage += "시간이 없는 줄이 있습니다. " + JSON.stringify(row,null," ") + " ";
          }
        });


        if(errorMessage != "") {
          this.jsonDataDirty = true;
          this.makeToast("danger", "형식에 맞지 않은 줄이 있습니다.", errorMessage, {
            "noAutoHide": true
          });
        }
        this.gridData = result.sort(this.sortFunc);
        this.markSameSecondAndSetIDAndSortByDuplicated();
      }
      catch(error) {
        this.jsonDataDirty = true;
        this.makeToast("danger", "JSON 변환 실패", "입력된 JSON 문자열이 형식에 맞지 않습니다.", {
          "noAutoHide": true
        });
      }
    },

    applyCsvToGrid: function() {
      if(this.csvData == "") return;
      let result = [];
      let errorMessage = "";
      let sensorValuesLength = this.pageSensorValuesFiltered.length;
      let rowSeperator = this.csvRowSeperator.replace("\\n", "\n").replace("\\t", "\t")
      let valueSeperator = this.csvValueSeperator.replace("\\n", "\n").replace("\\t", "\t")
      let rows = this.csvData.trim().split(rowSeperator);

      if(this.csvTimeFormat == "epoch") {
        rows.forEach((row,index) => {
          if(row != "") {
            let splitted = row.trim().split(valueSeperator);
            if(splitted.length == (sensorValuesLength+1)) {
              let item = {
                "d": {
                  "t": firebase.firestore.Timestamp.fromMillis(splitted[0]*1000),
                  "v": [],
                },
                "s": false,
                "n": true,
              };
              this.pageSensorValuesFiltered.forEach((value,index)=>{
                if(value.type == "BOOL_VAL") {
                  item.d.v.push((splitted[index+1].toLowerCase() === "true" || splitted[index+1]*1 > 0)? true : false);
                }
                else {
                  item.d.v.push(splitted[index+1]*1);
                }
              })
              result.push(item);
            }
            else {
              errorMessage += (index+1) + "번 줄 에러 발생. 내용:" + row + " ";
            }
          }
          else {
            errorMessage += (index+1) + "번 줄은 공백입니다. ";
          }
        });
      }
      else if(this.csvTimeFormat == "excel") {
        rows.forEach((row,index) => {
          if(row != "") {
            let splitted = row.trim().split(valueSeperator);
            if(splitted.length == (sensorValuesLength+1)) {
              let item = {
                "d": {
                  "t": firebase.firestore.Timestamp.fromDate(this.stringToDate(splitted[0])),
                  "v": [],
                },
                "s": false,
                "n": true,
              };
              this.pageSensorValuesFiltered.forEach((value,index)=>{
                if(value.type == "BOOL_VAL") {
                  item.d.v.push((splitted[index+1].toLowerCase() === "true" || splitted[index+1]*1 > 0)? true : false);
                }
                else {
                  item.d.v.push(splitted[index+1]*1);
                }
              })
              result.push(item);
            }
            else {
              errorMessage += (index+1) + "번 줄 에러 발생. 내용:" + row + " ";
            }
          }
          else {
            errorMessage += (index+1) + "번 줄은 공백입니다. ";
          }
        });
      }
      else {
        rows.forEach((row,index) => {
          if(row != "") {
            let splitted = row.trim().split(valueSeperator);
            if(splitted.length == (sensorValuesLength+1)) {
              let item = {
                "d": {
                  "t": firebase.firestore.Timestamp.fromDate(new Date(splitted[0])),
                  "v": [],
                },
                "s": false,
                "n": true,
              };
              this.pageSensorValuesFiltered.forEach((value,index)=>{
                if(value.type == "BOOL_VAL") {
                  item.d.v.push((splitted[index+1].toLowerCase() === "true" || splitted[index+1]*1 > 0)? true : false);
                }
                else {
                  item.d.v.push(splitted[index+1]*1);
                }
              })
              result.push(item);
            }
            else {
              errorMessage += (index+1) + "번 줄 에러 발생. 내용:" + row + " ";
            }
          }
          else {
            errorMessage += (index+1) + "번 줄은 공백입니다. ";
          }
        });
      }

      if(errorMessage != "") {
        this.csvDataDirty = true;
        this.makeToast("danger", "형식에 맞지 않은 줄이 있습니다.", errorMessage, {
          "noAutoHide": true
        });
      }
      this.gridData = result.sort(this.gridSortFunc);
      this.markSameSecondAndSetIDAndSortByDuplicated();
    },

    clickTab: function(tabIndex) {
      if(tabIndex != this.dataTabIndex) {
        // jsonTab
        if(this.dataTabIndex == 0 && this.jsonDataDirty) {
          this.applyJsonToGrid();
          this.applyGridToCsv();
          this.jsonDataDirty = false;
        }
        // csvTab
        else if(this.dataTabIndex == 1 && this.csvDataDirty) {
          this.applyCsvToGrid();
          this.applyGridToJson();
          this.csvDataDirty = false;
        }
        // gridTab -> jsonTab, csvTab
        else if(this.dataTabIndex == 2 && this.jsonDataDirty && this.csvDataDirty) {
          this.applyGridToCsv();
          this.applyGridToJson();
          this.csvDataDirty = false;
          this.jsonDataDirty = false;
        }
      }
    },
    setJsonDataDirty: function() {
      this.jsonDataDirty = true;
    },
    setCsvDataDirty: function() {
      this.csvDataDirty = true;
    },

    gridSortFunc: function(a,b) {
      if(a.d.t.seconds > b.d.t.seconds) return 1;
      else if(a.d.t.seconds == b.d.t.seconds) {
        if(a.n == true & b.n == false) 1;
        if(a.n == false & b.n == true) -1;
        if(a.s == true & b.s == false) 1;
        if(a.s == false & b.s == true) -1;
        return 1;
      }
      else if(a.d.t.seconds < b.d.t.seconds) return -1;
      else return 0;
    },

    createSampleData: function() {
      let values = [];
      let seedDate = parseInt(Date.now()/1000);

      for(let i=0;i<this.sampleRowCountSelected;i++) {
        let row = {};
        row.d = {};
        row.d.t = firebase.firestore.Timestamp.fromMillis((seedDate-this.sampleRowCountSelected+i)*1000);
        row.d.v = [];
        row.s = false;
        row.n = true;

        this.pageSensorValuesFiltered.forEach((item,index)=>{
          if(this.sampleValueDifferentSelected || i== 0) {
            row.d.v.push(this.makeRandomValue(item.type, item.min, item.max, "strict"));
          }
          else {
            row.d.v.push(row[i-1].d.v[index]);
          }
        })

        values.push(row);
      }
      this.gridData = values.sort(this.gridSortFunc);
      this.dataTabIndex = 2;
      this.csvDataDirty = false;
      this.jsonDataDirty = false;
      this.applyGridToCsv();
      this.applyGridToJson();
      this.isGridDataMerged = false;
      this.markSameSecondAndSetIDAndSortByDuplicated();
    },
    getTypedArrayByteLength: function(dataTypeStr) {
      if(dataTypeStr == "BOOL_VAL") return 1;
      else if(dataTypeStr == "INT_VAL") return 2;
      else if(dataTypeStr == "UNSIGNED_INT_VAL") return 2;
      else return 4;
    },
    readFromBuffer: function(source, pos, type) {
      switch(type) {
        case "UNSIGNED_INT_VAL":
        return source.getUint16(pos, true);
        case "INT_VAL":
        return source.getInt16(pos, true);
        case "UNSIGNED_LONG_VAL":
        return source.getUint32(pos, true);
        case "FLOAT_VAL":
        return source.getFloat32(pos, true);
        case "LONG_VAL":
        return source.getInt32(pos, true);
        default:
        return source.getInt8(pos, true);
      }
    },
    TypedArray: function(dataTypeStr) {
      switch(dataTypeStr) {
        case "UNSIGNED_INT_VAL":
        return Uint16Array;
        case "UNSIGNED_LONG_VAL":
        return Uint32Array;
        case "FLOAT_VAL":
        return Float32Array;
        case "INT_VAL":
        return Int16Array;
        case "LONG_VAL":
        return Int32Array;
        case "BOOL_VAL":
        return Int8Array;
        default:
        return Int8Array;
      }
    },
    convertFilesToData: function() {
      let values = [];
      let hasStrangeTime = false;

      this.dataFiles.forEach((file, index) => {

        let reader = new FileReader();
        let nowMillis = (firebase.firestore.Timestamp.now()).seconds;

        reader.onload = (() => {
          let ext = file.name.substr(file.name.lastIndexOf(".") + 1);

          if(ext == "bin" || ext == "BIN") {

            let cIndex = 0;
            let readValue;
            let dataView = new DataView(reader.result);
            let errorCode = 0;

            while(cIndex < dataView.byteLength && errorCode == 0) {
              let value = {};
              value.d = {};

              if((cIndex + this.getTypedArrayByteLength("UNSIGNED_LONG_VAL")) > dataView.byteLength) {
                errorCode = -1; // 시간을 읽으려는 데 길이에 문제가 있음.
                break;
              }

              readValue = this.readFromBuffer(dataView, cIndex, "UNSIGNED_LONG_VAL");

              // 8963 8051 1


              if(readValue < 1181986920) {
                 errorCode = -2; // 시간을 읽으려는 데 너무 과거임. binary 형식은 2007년 6월 16일 이전이 안됨.
                 break;
              }

              if(readValue > (nowMillis+60)) {
                errorCode = -3; // 시간을 읽으려는 데 미래임. binary 형식은 현재 시간 이후 데이터를 저장할 수 없음.
                break;
              }

              value.d.t = firebase.firestore.Timestamp.fromMillis(readValue*1000);
              cIndex += this.getTypedArrayByteLength("UNSIGNED_LONG_VAL");
              value.d.v = [];
              value.n = true;

              for(let valueIndex=0; valueIndex < this.pageSensorValuesFiltered.length && errorCode == 0; valueIndex++) {

                if((cIndex + this.getTypedArrayByteLength(this.pageSensorValuesFiltered[valueIndex].type)) > dataView.byteLength) {
                  errorCode = -4; // 데이터를 읽으려는 데 길이에 문제가 있음.
                  break;
                }

                readValue = this.readFromBuffer(dataView, cIndex, this.pageSensorValuesFiltered[valueIndex].type);

                if(this.pageSensorValuesFiltered[valueIndex].type == "FLOAT_VAL") {
                  if(readValue > 3.4028235E+38 && readValue < -3.4028235E+38) {
                    errorCode = -5; // float 값이 너무 큼
                    break;
                  }

                  if(typeof(this.pageSensorValuesFiltered[valueIndex].diff) == "undefined") {
                    value.d.v.push(Math.round(readValue*100)/100);
                  }
                  else {
                    let diff = Math.round(1/this.pageSensorValuesFiltered[valueIndex].diff);
                    value.d.v.push(Math.round(readValue*diff)/diff);
                  }
                }

                else if(this.pageSensorValuesFiltered[valueIndex].type == "UNSIGNED_LONG_VAL") {
                  if(readValue > 4294967295 || readValue < 0) {
                    errorCode = -6; // 4바이트 unsigned long 값이 이상함
                    break;
                  }
                  else {
                    value.d.v.push(readValue);
                  }
                }
                else if(this.pageSensorValuesFiltered[valueIndex].type == "LONG_VAL") {
                  if(readValue < -2147483648 || readValue > 2147483647) {
                    errorCode = -7; // 4바이트 long 값이 이상함
                    break;
                  }
                  else {
                    value.d.v.push(readValue);
                  }
                }
                else if(this.pageSensorValuesFiltered[valueIndex].type == "BOOL_VAL") {
                  if(readValue !== 0 && readValue !== 1) {
                    errorCode = -8; // bool 값이 0 또는 1이 아님
                    break;
                  }
                  else {
                    value.d.v.push(readValue);
                  }
                }
                else if(this.pageSensorValuesFiltered[valueIndex].type == "INT_VAL") {
                  if(readValue > 32767 || readValue < -32768) {
                    errorCode = -9; // 2바이트 int 값이 이상함
                    break;
                  }
                  else {
                    value.d.v.push(readValue);
                  }
                }
                else if(this.pageSensorValuesFiltered[valueIndex].type == "UNSIGNED_INT_VAL") {
                  if(readValue < 0 || readValue > 65535) {
                    errorCode = -10; // 2바이트 unsigned int 값이 이상함
                    break;
                  }
                  else {
                    value.d.v.push(readValue);
                  }
                }
                cIndex += this.getTypedArrayByteLength(this.pageSensorValuesFiltered[valueIndex].type);
              }
              if(errorCode != 0) break;
              values.push(value);
            }

            if(errorCode != 0) {
              let errorMessage = (cIndex+1) + "바이트 이후 데이터는 변환이 되지 않았습니다. ";
              if(errorCode == -1) errorMessage += "시간 데이터의 길이가 4바이트 미만입니다.";
              else if(errorCode == -2) errorMessage += "시간 데이터가 너무 과거입니다.";
              else if(errorCode == -3) errorMessage += "시간 데이터가 미래입니다.";
              else if(errorCode == -4) errorMessage += "남은 바이트가 너무 짧습니다.";
              else if(errorCode == -5) errorMessage += "4바이트 float 값이 이상합니다.";
              else if(errorCode == -6) errorMessage += "4바이트 unsigned long int 값이 이상합니다.";
              else if(errorCode == -7) errorMessage += "4바이트 long int 값이 이상합니다.";
              else if(errorCode == -8) errorMessage += "boolean 값이 0 또는 1이 아닙니다.";
              else if(errorCode == -9) errorMessage += "2바이트 int 값이 이상합니다.";
              else if(errorCode == -10) errorMessage += "2바이트 unsigned int 값이 이상합니다.";
              errorMessage += " 위치: " + (cIndex+1) + "바이트 이후, ";
              errorMessage += " 값: " + readValue;
              this.makeToast("danger", file.name + " 파일 가져오기 실패", errorMessage, {
                "noAutoHide": true
              });
            }
          }

          else {


            let rows = reader.result.split(/[(\r\n)|\n]/);
            let errorRow = [];

            rows.forEach((item, rowIndex) => {
              if(item != "") {
                let row = item.split(this.csvValueSeperator);
                let errorCode = 0;
                if(row.length == (this.pageSensorValuesFiltered.length+1)) {
                  let value = {};
                  value.n = true;
                  value.d = {};
                  value.d.t = firebase.firestore.Timestamp.fromMillis(row[0]*1000);
                  if(value.d.t.seconds < 1181986920) hasStrangeTime = true;
                  if(value.d.t.seconds > (nowMillis+60)) hasStrangeTime = true;
                  value.d.v = [];
                  for(let valueIndex=0; valueIndex < this.pageSensorValuesFiltered.length && errorCode == 0; valueIndex++) {

                    // row[valueIndex+1] = row[valueIndex+1]*1;

                    if(this.pageSensorValuesFiltered[valueIndex].type == "FLOAT_VAL") {
                      if(row[valueIndex+1]*1 > 3.4028235E+38 && row[valueIndex+1]*1 < -3.4028235E+38) {
                        errorCode = -5; // float 값이 너무 큼
                        break;
                      }
                      if(typeof(this.pageSensorValuesFiltered[valueIndex].diff) == "undefined") {
                        value.d.v.push(Math.round(row[valueIndex+1]/0.01)*0.01);
                      }
                      else {
                        value.d.v.push(Math.round(row[valueIndex+1]/this.pageSensorValuesFiltered[valueIndex].diff)*this.pageSensorValuesFiltered[valueIndex].diff);
                      }
                    }

                    else if(this.pageSensorValuesFiltered[valueIndex].type == "UNSIGNED_LONG_VAL") {
                      if(row[valueIndex+1]*1 > 4294967295 || row[valueIndex+1]*1 < 0) {
                        errorCode = -6; // 4바이트 unsigned long 값이 이상함
                        break;
                      }
                      else {
                        value.d.v.push(row[valueIndex+1]);
                      }
                    }

                    else if(this.pageSensorValuesFiltered[valueIndex].type == "LONG_VAL") {
                      if(row[valueIndex+1]*1 < -2147483648 || row[valueIndex+1]*1 > 2147483647) {
                        errorCode = -7; // 4바이트 unsigned long 값이 이상함
                        break;
                      }
                      else {
                        value.d.v.push(row[valueIndex+1]);
                      }
                    }

                    else if(this.pageSensorValuesFiltered[valueIndex].type == "BOOL_VAL") {
                      if(row[valueIndex+1] == "false" || row[valueIndex+1]*1 <= 0) {
                        value.d.v.push(false);
                      }
                      else {
                        value.d.v.push(true);
                      }
                    }

                    else if(this.pageSensorValuesFiltered[valueIndex].type == "INT_VAL") {
                      if(row[valueIndex+1]*1 > 32767 || row[valueIndex+1]*1 < -32768) {
                        errorCode = -9; // 2바이트 int 값이 이상함
                        break;
                      }
                      else {
                        value.d.v.push(row[valueIndex+1]);
                      }
                    }

                    else if(this.pageSensorValuesFiltered[valueIndex].type == "UNSIGNED_INT_VAL") {
                      if(row[valueIndex+1]*1 < 0 || row[valueIndex+1]*1 > 65535) {
                        errorCode = -10; // 2바이트 unsigned int 값이 이상함
                        break;
                      }
                      else {
                        value.d.v.push(row[valueIndex+1]);
                      }
                    }

                  }
                  if(errorCode != 0) {
                    errorRow.push({ "row": rowIndex, "code": errorCode });
                  }
                  else {
                    values.push(value);
                  }
                }
                else {
                  errorCode = -11;
                  errorRow.push({ "row": rowIndex, "code": errorCode });
                }
              }
            });

            if(errorRow.length > 30) {
              let errorMessage = errorRow.length + "개의 줄이 에러로 변환되지 않았습니다.";
              this.makeToast("danger", file.name + " 파일 가져오기 실패", errorMessage, {
                "noAutoHide": true
              });
            }
            else if(errorRow.length > 5) {
              let errorMessage = errorRow.length + "개의 줄이 에러로 변환되지 않았습니다. 변환되지 않은 줄: ";
              errorRow.forEach((error,errorIndex) => {
                errorMessage += (error.row+1);
                if(errorIndex != (errorRow.length-1)) errorMessage += ", ";
              });
              this.makeToast("danger", file.name + " 파일 가져오기 실패", errorMessage, {
                "noAutoHide": true
              });
            }
            else if(errorRow.length > 0) {
              let errorMessage = "";
              errorRow.forEach(error => {
                errorMessage += (error.row+1) +"번째 줄에 문제가 있습니다("
                if(error.code == -5) errorMessage += "float 값이 이상함)";
                else if(error.code == -6) errorMessage += "4바이트 unsigned long int 값이 이상함";
                else if(error.code == -7) errorMessage += "4바이트 long int 값이 이상함";
                else if(error.code == -8) errorMessage += "boolean 값이 0 또는 1이 아님";
                else if(error.code == -9) errorMessage += "2바이트 int 값이 이상함";
                else if(error.code == -10) errorMessage += "2바이트 unsigned int 값이 이상함";
                else if(error.code == -11) errorMessage += "항목수가 다름";
                errorMessage += "). ";
              });
              this.makeToast("danger", file.name + " 파일 가져오기 실패", errorMessage, {
                "noAutoHide": true
              });
            }
          }

          if(index == (this.dataFiles.length-1)) {
            if(values.length == 0) {
              this.makeToast("danger", "파일 가져오기 실패", "가져올 데이터가 없습니다.", {
                "noAutoHide": true
              });
            }
            else {
              this.gridData = values.sort(this.gridSortFunc);
              this.dataTabIndex = 2;
              this.csvDataDirty = true;
              this.jsonDataDirty = true;
              this.isGridDataMerged = false;
              this.markSameSecondAndSetIDAndSortByDuplicated();
              // isLastFile = false;
              this.makeToast("info", "파일 가져오기 성공", "총 " + values.length + " 줄의 데이터를 가져왔습니다.");
            }
            this.dataFiles = [];
          }
        });

        // if(index == (this.dataFiles.length-1)) isLastFile = true;

        let ext = file.name.substr(file.name.lastIndexOf(".") + 1);
        if(ext == "bin" || ext == "BIN") reader.readAsArrayBuffer(file);
        else reader.readAsText(file);
      });
    },

    markSameSecondAndSetIDAndSortByDuplicated: function() {
      this.gridData.forEach((item, index, source)=>{
        item.id = index;
        if(index != 0) {
          if(item.d.t.seconds == source[index-1].d.t.seconds) {
            source[index-1]._rowVariant = "danger";
            item._rowVariant = "danger";
          }
          else {
            delete(item._rowVariant);
          }
        }
        else {
          delete(item._rowVariant);
        }
      });
      if(this.gridDataRowCountDuplicated > 0) {
        this.gridSortBy = "_rowVariant";
        this.gridSortDesc = true;
      }
      else {
        this.gridSortBy = "id";
        this.gridSortDesc = true;
      }
    },

    resetGrid: function() {
      this.gridUpdating = false;
      this.gridData = [];
      this.csvData = "";
      this.jsonData = "";
      this.csvDataDirty = false;
      this.jsonDataDirty = false;
      this.isGridDataMerged = false;
    },

    mergeGridData: function() {
      let startBook = this.getBookIndexFrom(this.gridData[0].d.t.seconds);
      for(let i=startBook;i<=this.pageSensor.lastBook;i++) {
        if(typeof(this.$parent.$parent.pageSensorHistory[i]) == "undefined" || this.$parent.$parent.pageSensorHistory[i].dirty) {
          return this.makeToast("danger", "데이터 업로드 에러", "합칠 데이터 조회가 실패했습니다.");
        }
      }
      let gridDataToAttach = [];
      if(this.pageSensor.lastValues != null) {
        for(let book=startBook;book<=this.pageSensor.lastBook;book++) {
          for(let i=0;i<1000;i++) {
            if(typeof(this.$parent.$parent.pageSensorHistory[book].data[i]) == "undefined") break;
            let item = {};
            item.n = false;
            item.s = false;
            item.d = this.$parent.$parent.pageSensorHistory[book].data[i];
            gridDataToAttach.push(item);
          }
        }
      }
      this.gridData = this.gridData.concat(gridDataToAttach).sort(this.gridSortFunc);
      this.isGridDataMerged = true;
      this.dataTabIndex = 2;
      this.csvDataDirty = true;
      this.jsonDataDirty = true;
      this.markSameSecondAndSetIDAndSortByDuplicated();
      this.hideModal("confirmDataMixFloat");
      if(this.gridDataRowCountDuplicated == 0) {
        this.makeToast("success", "데이터 합치기 성공", "서버의 데이터를 가져와서 합쳤습니다. 검토 후에 업로드를 누르세요.");
      }
      else {
        this.makeToast("warning", "데이터 합치기 성공", "서버의 데이터를 가져와서 합쳤습니다. 시간이 동일한 줄은 1개만 남기고 삭제해야 업로드할 수 있습니다.");
      }
    },

    uploadGridDataNow: function() {

      this.hideModal("confirmDataMixFloat");

      if(this.onlyCotainsLateValues && !this.isGridDataMerged) {

        let lastBookLeftCount = 1000 - this.pageSensor.lastIndex - 1;
        let lastBookValues = { owner: this.pageUser.id };
        let lastBookValuesLength = 0;

        let nextBooksValues = [];
        let nextBooksValuesLength;

        if(this.gridData.length <= lastBookLeftCount) {
          nextBooksValuesLength = 0;
        }
        else {
          nextBooksValuesLength = Math.ceil((this.gridData.length-lastBookLeftCount)/1000);
        }

        for(let i=0;i<nextBooksValuesLength;i++) nextBooksValues.push({ owner: this.pageUser.id });

        this.gridData.forEach((item,index) => {
          if(index < lastBookLeftCount) {
            lastBookValues[this.pageSensor.lastIndex + index + 1] = item.d;
            lastBookValuesLength++;
          }
          else {
            nextBooksValues[Math.floor((index-lastBookLeftCount)/1000)][index -lastBookLeftCount - Math.floor((index-lastBookLeftCount)/1000)*1000] = item.d;
          }
        });

        if(this.gridData.length > lastBookLeftCount) {
          if(lastBookLeftCount != 0) {
            if(typeof(this.pageSensor.bookInfo[this.pageSensor.lastBook]) == "undefined") {
              this.pageSensor.bookInfo[this.pageSensor.lastBook] = {};
            }
            this.pageSensor.bookInfo[this.pageSensor.lastBook].to = lastBookValues[this.pageSensor.lastIndex + lastBookValuesLength].t;
            if(typeof(this.pageSensor.bookInfo[this.pageSensor.lastBook].from) == "undefined") {
              this.pageSensor.bookInfo[this.pageSensor.lastBook].from = lastBookValues[this.pageSensor.lastIndex+1].t;
            }
          }

          this.$log.debug(lastBookLeftCount);
          this.$log.debug((this.gridData.length - lastBookLeftCount)%1000-1);
          this.$log.debug(nextBooksValues);

          nextBooksValues.forEach((item, index) => {
            if(index == (nextBooksValues.length-1)) {
              let lastIndex = (this.gridData.length - lastBookLeftCount)%1000-1;
              if(lastIndex < 0) lastIndex = 999;
              this.pageSensor.bookInfo[this.pageSensor.lastBook+index+1] = {
                from: item[0].t,
                to: item[lastIndex].t
              };
            }
            else {
              this.pageSensor.bookInfo[this.pageSensor.lastBook+index+1] = {
                from: item[0].t,
                to: item[999].t
              };
            }
          })

          this.$log.debug(this.pageSensor.bookInfo);

        }
        else {
          if(this.pageSensor.lastIndex == -1 && this.gridData.length > 0) {
            this.pageSensor.bookInfo[0] = { from: this.gridData[0].d.t, to: this.gridData[this.gridData.length-1].d.t };
          }
          else {
            this.pageSensor.bookInfo[this.pageSensor.lastBook].to = this.gridData[this.gridData.length-1].d.t;
          }
        }

        let batch = db.batch();

        if(lastBookLeftCount != 0) {
          batch.set(db.collection("sensors").doc(this.pageSensor.id).collection("history").doc(""+ this.pageSensor.lastBook), lastBookValues, {merge: true});
        }

        nextBooksValues.forEach((item, index) => {
          batch.set(db.collection("sensors").doc(this.pageSensor.id).collection("history").doc(""+ (this.pageSensor.lastBook + index + 1)), item);
        });

        let lastValuesModified = firebase.firestore.Timestamp.now();
        let oldLastValuesModified = this.lastValuesModified;
        this.lastValuesModified = lastValuesModified.toDate();

        batch.update(db.collection("sensors").doc(this.pageSensor.id), {
          "lastBook": this.pageSensor.lastBook + nextBooksValues.length,
          "lastIndex": (this.pageSensor.lastIndex + this.gridData.length)%1000,
          "lastValues": this.gridData[this.gridData.length-1].d,
          "bookInfo": this.pageSensor.bookInfo,
          "lastValuesModified": lastValuesModified
        });

        this.gridUpdating = true;
        batch.commit()
        .then(() => {

          let lastBookFilled = Math.min(lastBookLeftCount, this.gridData.length);

          if(typeof(this.$parent.$parent.pageSensorHistory[this.lastBook]) != "undefined" && this.lastIndex == -1) {
            for(let i=0;i<lastBookFilled;i++) {
              this.$parent.$parent.pageSensorHistory[this.lastBook].data[this.lastIndex+i+1] = this.gridData[i].d;
            }
          }

          nextBooksValues.forEach((item, index) => {
            this.$parent.$parent.pageSensorHistory[this.lastBook+1+index] = { dirty: false };
            this.$parent.$parent.pageSensorHistory[this.lastBook+1+index].data = item;
          });

          this.lastBook = this.pageSensor.lastBook;
          this.lastIndex = this.pageSensor.lastIndex;
          this.resetGrid();
          this.makeToast("success", "데이터 업로드 성공", "데이터를 업로드했습니다.");
          this.gridUpdating = false;
        })
        .catch(error => {
          this.lastValuesModified = oldLastValuesModified;
          this.resetGrid();
          this.makeToast("danger", "데이터 업로드 실패", "데이터 업로드 중 에러가 발생했습니다. 에러 내용: " + error, {
            "noAutoHide": true
          });
          this.gridUpdating = false;
        })
      }

      else {

        let startBook = this.getBookIndexFrom(this.gridData[0].d.t.seconds);

        let newBooks = {};
        let newBooksLength = Math.ceil(this.gridData.length/1000);
        let batch = db.batch();
        for(let i=startBook;i<this.pageSensor.lastBook;i++) {
          batch.delete(db.collection("sensors").doc(this.pageSensor.id).collection("history").doc(i+""));
        }
        for(let i=startBook;i<(startBook+newBooksLength);i++) {
          newBooks[i] = { owner: this.pageUser.id };
        }

        this.gridData.forEach((element,elementIndex) => {
          newBooks[startBook + Math.floor(elementIndex/1000)][elementIndex%1000] = element.d;
        });

        for(let i=startBook;i<(startBook+newBooksLength);i++) {
          batch.set(db.collection("sensors").doc(this.pageSensor.id).collection("history").doc(i+""), newBooks[i]);
          if(typeof(this.pageSensor.bookInfo[i]) == "undefined") {
            this.pageSensor.bookInfo[i] = {};
          }
          this.pageSensor.bookInfo[i].from = newBooks[i][0].t;
          this.pageSensor.bookInfo[i].to = (i==(startBook+newBooksLength-1))? newBooks[i][(this.gridData.length-1)%1000].t: newBooks[i][999].t;
        }

        batch.update(db.collection("sensors").doc(this.pageSensor.id), {
          "lastBook": startBook + newBooksLength - 1,
          "lastIndex": (this.gridData.length-1)%1000,
          "bookInfo": this.pageSensor.bookInfo,
          "lastValues": this.gridData[this.gridData.length-1].d,
          "lastValuesModified": firebase.firestore.Timestamp.now()
        });

        this.gridUpdating = true;
        batch.commit()
        .then(() => {
          for(let i=startBook;i<(startBook+newBooksLength);i++) {
            this.$parent.$parent.pageSensorHistory[i] = { dirty: false };
            this.$parent.$parent.pageSensorHistory[i].data = newBooks[i];
          }
          this.lastBook = this.pageSensor.lastBook;
          this.lastIndex = this.pageSensor.lastIndex;
          this.lastValuesModified = this.pageSensor.lastValuesModified.toDate();
          this.resetGrid();
          this.makeToast("success", "데이터 업로드 성공", "데이터를 업로드했습니다.");
          this.gridUpdating = false;
        })
        .catch(error => {
          this.gridData = [];
          this.csvData = "";
          this.jsonData = "";
          this.isGridDataMerged = false;
          this.makeToast("danger", "데이터 업로드 실패", "데이터 업로드 중 에러가 발생했습니다. 에러 내용: " + error, {
            "noAutoHide": true
          });
          this.gridUpdating = false;
        })
      }
    },

    preloadHistoryData: function() {
      let toRequest = [];

      let books = this.getBookIndexFrom(this.gridData[0].d.t.seconds);

      if((this.pageSensor.lastBook - books) > this.maxGridDataMergeLength) {
        this.makeToast("danger", "합칠 데이터가 너무 많습니다.", "서버에서 최대 5개의 묶음을 가져와서 합칠 수 있습니다. 데이터를 다운로드해서 정리한 다음에 올리거나 올릴 데이터와 시간이 겹치지 않는 최신 데이터 묶음은 백업 후에 삭제한 다음에 업로드를 하세요.");
        return;
      }

      for(let i=books;i<=this.pageSensor.lastBook;i++) {
        if(typeof(this.$parent.$parent.pageSensorHistory[i]) == "undefined") {
          toRequest.push(i);
        }
        else if(this.$parent.$parent.pageSensorHistory[i].dirty) {
          toRequest.push(i);
        }
      }

      if(toRequest.length !=0) {
        let successCount = 0;
        toRequest.forEach(item => {
          db.collection("sensors").doc(this.pageSensor.id).collection("history").doc(item+ "")
          .get()
          .then(book => {
            if(book.exists) {
              this.$parent.$parent.pageSensorHistory[item+""] = { dirty: false, data: book.data() } ;
              if(++successCount == toRequest.length) {
                this.mergeGridData();
              }
            }
            else {
              if(item == 0) this.makeToast("warning", "데이터 조회 결과", "데이터가 없습니다.");
              else this.makeToast("warning", "데이터 조회 결과", item + "번 묶음 데이터가 없습니다.");
            }
          })
          .catch(error => {
            this.makeToast("danger", "데이터 조회중", "데이터 조회 중 에러가 발생했습니다. 에러 내용: " + error);
          })
        })
      }
      else {
        this.mergeGridData();
      }
    },

    uploadGridData: function() {

      if(this.dataTabIndex == 0 && this.jsonDataDirty) {
        this.applyJsonToGrid();
        this.applyGridToCsv();
        this.jsonDataDirty = false;
      }
      else if(this.dataTabIndex == 1 && this.csvDataDirty) {
        this.applyCsvToGrid();
        this.applyGridToJson();
        this.csvDataDirty = false;
      }

      else if(this.gridData.length == 0) {
        this.makeToast("danger", "업로드 데이터 없음", "업로드할 데가 없습니다.");
      }

      else if(this.gridData.length > 10000) {
        this.makeToast("danger", "업로드 데이터가 너무 큽니다", "최대 10000줄의 데이터까지 동시에 업로드할 수 있습니다.");
      }

      else if(this.pageSensor.lastValues == null) {
        // this.showModal("uploadFunctionServerFloat");
        this.uploadFunctionServer();
      }
      else if(this.onlyCotainsLateValues || this.isGridDataMerged) {
        // !this.pageDevice.active
        this.uploadGridDataNow();
      }
      else {
        this.showModal("confirmDataMixFloat");
      }
    }
  }
}
</script>
<style scoped>
.grid th { padding : 0.6ex 0.4ex 0.6ex 0.4ex; text-align: center; font-size: 1rem}
.grid td { padding : 0.6ex 0.4ex 0.6ex 0.4ex; vertical-align: baseline;  font-size: 1rem }
.grid .dataTd { text-align : right; padding-right: 1ex }
.grid .timeTd { text-align : left; padding-right: 1ex }
.grid .centerTd { text-align : center; }

.menuText { vertical-align:-1px;font-size: 0.9rem;  }

.menuRow { display: grid; grid-template-areas: 'left right'; grid-column-gap: 1ex; grid-template-columns: auto 100px; border-style: solid; border-color:#dee2e6; border-width: 1px 1px 1px 1px; font-family: 'Nanum Gothic', sans-serif; padding: 0px; margin: 2px 0px 0px 0px;
}

.menuRowAuto { display: grid; grid-template-areas: 'left right'; grid-column-gap: 1ex; grid-template-columns: auto auto; border-style: solid; border-color:#dee2e6; border-width: 1px 1px 1px 1px; font-family: 'Nanum Gothic', sans-serif;
padding: 0px; margin: 0px;
}

.leftMenu { display:inline-block; border-right: 1px solid #dee2e6; padding: 4px 8px 4px 8px; }
.rightMenuBlock { grid-area: right; text-align: right; padding: 4px 4px 4px 4px; border-left : 1px solid #dee2e6; }

</style>
